import { useContext, useEffect, useState } from "react";

import { AppContext } from "../context/AppContext";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { CartContext } from "../context/CartContext";
import Container from "@mui/material/Container";
import { Helmet } from "react-helmet";
import Paper from "@mui/material/Paper";
import parse from "html-react-parser";
import Typography from "@mui/material/Typography";
import { getActiveEvent } from "../services/firebase";
import { useNavigate } from "react-router-dom";

export const Welcome = () => {
  const { member, memberPasses } = useContext(AppContext);
  const { addToCart } = useContext(CartContext);
  const [activeEvent, setActiveEvent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchActiveEvent = async () => {
      const event = await getActiveEvent();
      setActiveEvent(event);
    };
    fetchActiveEvent();
  }, []);

  const handleSignIn = () => {
    navigate("/signin");
  };

  const handleCreateAccount = () => {
    navigate("/signin");
  };

  const handlePurchasePass = () => {
    navigate("/checkout");
  };

  const handleCheckIn = () => {
    navigate("/checked-in");
  };

  const handlePurchaseEventTicket = () => {
    if (activeEvent) {
      addToCart(activeEvent.tickets[0]); // Add first ticket type to cart
      navigate("/checkout");
    }
  };

  return (
    <Container maxWidth="sm">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Welcome to The Cola St. Louis</title>
      </Helmet>
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Welcome to The Cola St. Louis
        </Typography>
        <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
          {!member ? (
            <>
              <Typography variant="h6" gutterBottom>
                Please sign in or create an account to continue
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSignIn}
                fullWidth
                sx={{ mt: 2 }}
              >
                Sign In
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleCreateAccount}
                fullWidth
                sx={{ mt: 2 }}
              >
                Create Account
              </Button>
            </>
          ) : (
            <>
              <Typography variant="h6" gutterBottom>
                Welcome back, {member.displayName}!
              </Typography>
              {memberPasses.length > 0 ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleCheckIn}
                  fullWidth
                  sx={{ mt: 2 }}
                >
                  Check In with Your Pass
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlePurchasePass}
                  fullWidth
                  sx={{ mt: 2 }}
                >
                  Purchase a Pass
                </Button>
              )}
            </>
          )}
        </Paper>
        {activeEvent && (
          <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
            <Typography variant="h5" gutterBottom>
              {activeEvent.name}
            </Typography>
            <Typography variant="body1" gutterBottom>
              {parse(activeEvent.description || "")}
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              onClick={handlePurchaseEventTicket}
              fullWidth
              sx={{ mt: 2 }}
            >
              Purchase Event Ticket
            </Button>
          </Paper>
        )}
      </Box>
    </Container>
  );
};

export default Welcome;
